import { useEffect, useState } from 'react';
import img from '../../../../assets/images/layout.webp';
import Ad from '../../../../components/Ad';
import AdsService from '../../../../services/AdsService';
import * as styles from './styles';

export default function Imgs() {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    async function loadAds() {
      try {
        const banners = await AdsService.listAds('HOME');

        setAds(banners);
      } catch (error) {
        console.log(error);
      }
    }

    loadAds();
  }, []);

  return (
    <styles.Container>
      <img src={img} alt="layout" />

      {ads?.map((a) => (
        <Ad key={a.id} img={a.url} link={a.link} />
      ))}
    </styles.Container>
  );
}
